export default __webpack_public_path__ + "static/media/provider-search-ndis.f7633d36.png";